import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import routes from 'routes/constants/routes';
import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { logout } from 'modules/auth/services/user';
import Search from 'modules/dashboard/search';

const Dashboard = () => {
  const userInfo = useSelector((state) => state.auth?.info);
  const token = useSelector((state) => state.auth?.token);
  const navigate = useNavigate();

  if (!token || !userInfo) {
    return <Navigate to={routes.login} />;
  }

  /*if (!userInfo?.password_changed) {
    return <ChangePassword />;
  }*/
  const { profile } = userInfo;

  return (
    <div className="container mx-auto py-6 px-3">
      <div className="flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="flex items-center">
          <div className="text-center md:text-left">
            <p className="text-lg">
              Xin chào{' '}
              <span className="font-semibold">{profile?.sale_name}</span>
            </p>
          </div>
        </div>
        <div className="space-x-3">
          {/*<Button
            onClick={() => navigate(routes.changePassword)}
            icon={<LockOutlined />}
          >
            Thay đổi mật khẩu
          </Button>*/}
          <Button icon={<LogoutOutlined />} onClick={logout} danger>
            Đăng xuất
          </Button>
        </div>
      </div>
      <div className="mt-6">
        <Search />
      </div>
    </div>
  );
};

export default Dashboard;
